export enum EEmailNotifications {
  NewOrder = 'New order',
  ResultsReady = 'Results ready',
}
